<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="标题" name="title"></c-form-item>
                    <c-form-item type="datetime" label="发布时间" start-name="start_publish_date" end-name="end_publish_date"></c-form-item>
                    <c-form-item type="checkbox" label="状态" name="status" :options="statusOptions"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button color="sys" icon="add" @click="navigateTo(`/platform_notice_add`)" power="b_platform_notice_edit">发布新公告</c-button>
            </m-operate>

            <c-table ref="table" code="abstract_consultation">
                <c-table-column
                        label="状态"
                        name="status"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.status==0"><span style="color:orange">草稿</span></span>
                        <span v-if="data.status==1"><span style="color:darkgreen">已发布</span></span>
                        <span v-if="data.status==2"><span style="color:gray">已撤回</span></span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="标题"
                        name="title"
                        width="300"
                >
                </c-table-column>

                <c-table-column
                        label="编辑时间"
                        name="update_time"
                        width="150"
                >
                </c-table-column>
                <c-table-column
                        label="发布人"
                        name="publish_user_name"
                        width="100"
                >
                </c-table-column>
                <c-table-column
                        label="发布时间"
                        name="publish_time"
                        width="150"
                >
                </c-table-column>
                <c-table-column
                        label="通知发送状态"
                        name="send_status"
                        width="100"
                >
                    <template v-slot="{data}">
                        <span v-if="data.send_status==0"><span style="color:dimgray">未发送</span></span>
                        <span v-if="data.send_status==1"><span style="color:dodgerblue">已发送</span></span>
                    </template>
                </c-table-column>
                <c-table-column
                        label="发送人"
                        name="send_user_name"
                        width="100"
                >
                </c-table-column>
                <c-table-column
                        label="发送时间"
                        name="send_time"
                        width="150"
                >
                </c-table-column>
                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="170"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_platform_notice_view" @click="navigateTo(`/platform_notice_detail/${data.id}`)">查看</c-table-button>
                        <c-table-button power="b_platform_notice_edit" v-if="data.status == 0"  @click="publishHandle(data)">发布</c-table-button>
                        <c-table-button power="b_platform_notice_send" v-if="data.status == 1 && data.send_status==0"  @click="sendHandle(data)">发送通知</c-table-button>
                        <c-table-button power="b_platform_notice_edit" v-if="data.status == 1"  @click="withdrawHandle(data)">撤回</c-table-button>
                        <c-table-button power="b_platform_notice_edit" v-if="data.status == 0 || data.status == 1"@click="navigateTo(`/platform_notice_edit/${data.id}`)">编辑</c-table-button>
                        <c-table-button power="b_platform_notice_edit" v-if="data.status == 0" @click="deleteHandle(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
    var name = 'm_platform_notice';
    var urls = {
        list:'/platform/notice/list', //列表数据
        del:'/platform/notice/remove', //删除
        publish:'/platform/notice/publish', //发布
        withdraw:'/platform/notice/withdraw', //撤回
        send:'/platform/notice/send', //撤回
    }
    export default {
        name: name,

        data() {
            return {
                editState: false,
                statusOptions: [
                    {value:0,name:'草稿'},
                    {value:1,name:'已发布'},
                    {value:2,name:'已撤回'}
                ]
            }
        },

        mounted() {
            this.$refs.search.search();

            this.$bus.$on('m_platform_notice.update', page => {
                this.$refs.table.update(page);
            });
        },

        beforeDestroy() {
            this.$bus.$off('m_platform_notice.update');
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: urls.list,
                    data
                });
            },

            editHandle(row) {
                this.editState = true;
                this._edit = row.data.id;
                this._resolve = data => {
                    row.update(data);
                };
                this.$refs.form.set(row.data);
                this.$refs.dialog.open();
            },

            deleteHandle(val) {
                this.$confirm({
                    text: '确定要删除通知公告「'+val.title+'」？删除后不可恢复',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: urls.del,
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            publishHandle(val) {
                this.$confirm({
                    text: '确定要发布通知公告「'+val.title+'」？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: urls.publish,
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            withdrawHandle(val) {
                this.$confirm({
                    text: '确定撤回通知公告「'+val.title+'」？撤回后该公告将不再对用户展示',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: urls.withdraw,
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            sendHandle(val) {
                this.$confirm({
                    text: '确定要发送「'+val.title+'」服务通知给用户吗？发送后不可撤回',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: urls.send,
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
        }
    }
</script>
